import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

export default function isDashboardApp(location = window.location) {
  // E.g. localhost:3000 or dashboard.watershedclimate.com or proxy.localhost:3000
  const dashboardHost = getPublicRuntimeConfig('NEXT_PUBLIC_DASHBOARD_HOST');
  if (!dashboardHost) {
    return false;
  }
  const publicDashboardHost = new URL(dashboardHost);
  return location.host.includes(publicDashboardHost.host);
}
